import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiPriceListService} from "./api-price-list.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiPriceListService]
})
export class ApiPriceListModule { }
